import httpClient from '@/http-client'

export const get = (id, Options = {}) => {
  return httpClient
    .get(`/api/homework-corrections/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/homework-corrections', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/homework-corrections/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const download = (Options = {}) => {
  return httpClient
    .get('/api/files', { responseType: 'arraybuffer', ...Options })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update, download }
